var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    viewBox: "0 0 35 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2109 0C21.7755 0 26.1531 2.0091 29.3808 5.58533C32.6085 9.16156 34.4217 14.012 34.4217 19.0695C34.4217 25.5828 31.2167 30.9138 27.8395 34.7383C26.1522 36.6284 24.3112 38.3421 22.3397 39.8574L21.5251 40.4719L21.1426 40.7537L20.4217 41.2622L19.7791 41.6966L18.9836 42.2093C18.4436 42.5508 17.8326 42.7304 17.2109 42.7304C16.5891 42.7304 15.9781 42.5508 15.4381 42.2093L14.6426 41.6966L13.6482 41.0185L13.2811 40.7537L12.497 40.1752C10.3702 38.5809 8.38916 36.7599 6.5822 34.7383C3.20505 30.9117 0 25.5828 0 19.0695C0 14.012 1.81328 9.16156 5.04095 5.58533C8.26861 2.0091 12.6463 0 17.2109 0ZM17.2109 12.713C16.4575 12.713 15.7115 12.8774 15.0154 13.1969C14.3194 13.5163 13.687 13.9845 13.1542 14.5748C12.6215 15.165 12.1989 15.8658 11.9106 16.637C11.6223 17.4082 11.4739 18.2348 11.4739 19.0695C11.4739 19.9043 11.6223 20.7308 11.9106 21.5021C12.1989 22.2733 12.6215 22.974 13.1542 23.5643C13.687 24.1545 14.3194 24.6227 15.0154 24.9422C15.7115 25.2616 16.4575 25.426 17.2109 25.426C18.7324 25.426 20.1916 24.7563 21.2675 23.5643C22.3434 22.3722 22.9478 20.7554 22.9478 19.0695C22.9478 17.3837 22.3434 15.7669 21.2675 14.5748C20.1916 13.3827 18.7324 12.713 17.2109 12.713Z",
    fill: "#011B73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePin);
export default __webpack_public_path__ + "static/media/BluePin.1a242a44ab0ea2959a4b62ae21beb910.svg";
export { ForwardRef as ReactComponent };